/* IBM Confidential‌ - OCO Source Materials‌ - (C) COPYRIGHT IBM CORP. 2023 - The source code for this program is not published or otherwise‌ divested of its trade secrets, irrespective of what has been‌ deposited with the U.S. Copyright Office. */

import React from 'react';
import "../forgot-pwd-email-form/ForgotPwdEmailForm.scss";
import { AuthenticationService } from '../service/AuthenticationService';

import { Button, Form, TextInput } from 'carbon-addons-iot-react';
import { ArrowRight32 } from '@carbon/icons-react';
import { InlineNotification, NotificationActionButton, Loading } from "carbon-components-react";
import { AppMsg } from "../utils";

export class ForgotPwdEmailForm extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            email: '',
            isEmailSent: false,
            isInvalidEmail: false,
            showEmailLoading: false,
            disableContinue: true,
            errorMessage: '',
            isExceededLimit: false,
            height: window.innerHeight
        }
    }

    _setEmail(email) {
        this.setState({
            email: email,
            isInvalidEmail: false
        }, () => { this._validateInputFields() });
    }

    _validateInputFields() { 
        if (this.state.email !== '' && !this.state.isEmailSent && this.state.errorMessage === '') {
            this.setState({
                disableContinue: false
            });
        } else {
            this.setState({
                disableContinue: true
            });
        }
    }

    _enableContinueButton() {
        this.setState({
            isEmailSent: false,
            errorMessage: '',
            isExceededLimit: false
        }, () => { this._validateInputFields() });
    }

    handleSubmit(event) {
        event.preventDefault();
        this._validateEmail();
    }

    _handleAutofill(e) {
        if (e.animationName === "onAutoFillStart") {
            console.log('Auto Fill Detected');
            this._enableContinueButton();
        }
    }

    componentDidMount() {
        window.addEventListener('resize', this.handleResize);
    }
    
    componentWillUnmount(){
        window.removeEventListener('resize', this.handleResize);
    }
    
    handleResize = () => {
       this.setState({height: window.innerHeight});
    };

    _validateEmail() {
        let regexEmailValidation = new RegExp('[a-zA-Z0-9]+@[a-zA-Z0-9-]+[\.]+[a-zA-Z]{2,3}');
        if (regexEmailValidation.test(this.state.email)) {
            this.setState({
                isInvalidEmail: false,
                disableContinue: true,
                showEmailLoading: true
            }, () => {
                this._handleResetPassword();
            });
        } else {
            this.setState({
                disableContinue: true,
                isInvalidEmail: true,
                isEmailSent: false
            });
        }
    }

    _handleResetPassword() {
        AuthenticationService.resetPassword(this.state.email).then(
            () => {
                this.setState({
                    isEmailSent: true,
                    disableContinue: true,
                    showEmailLoading: false
                });
            },
            error => {
                let isExceededLimit = false;
                if (error && error.includes("Email exceeded limit")) {
                    error = AppMsg.getMessage(AppMsg.APP_SYSTEM_ERROR_EMAIL_EXCEEDED_LIMIT);
                    isExceededLimit = true;
                }
                this.setState({
                    isEmailSent: false,
                    errorMessage: error,
                    isExceededLimit: isExceededLimit,
                    disableContinue: true,
                    showEmailLoading: false
                });
            });
    }
    
    render() {
        return (
            <div className="login-main-wrapper" style={{ height: this.state.height }} >
                <div className='login-wrapper'>
                    <div className="login-header">
                        <div>
                            <label>{AppMsg.getMessage(AppMsg.APP_HAVING_TROUBLE_LOGGING_IN)}</label>
                        </div>
                    </div>
                    <div className="login-user-message">
                            <label>{AppMsg.getMessage(AppMsg.APP_HAVING_TROUBLE_LOGGING_IN_MSG)}</label>
                    </div>
                    {this.state.errorMessage ?
                        <div className="tri-inline-notification-div">
                            <InlineNotification
                                hideCloseButton={false}
                                iconDescription="close"
                                kind="error"
                                notificationType="inline"
                                onCloseButtonClick={() => this._enableContinueButton()}
                                role="alert"
                                statusIconDescription=""
                                subtitle={<>{this.state.errorMessage}
                                    {this.state.isExceededLimit ? 
                                    <div style={{display: "block"}}>
                                        <NotificationActionButton
                                            kind="tertiary"
                                            onClick={() => this.props.resetUserStateFromForgotPwdBackToLogin()} 
                                        >
                                            {AppMsg.getMessage(AppMsg.APP_BACK_TO_LOGIN)}
                                        </NotificationActionButton>
                                    </div> : ''}</>}
                                title={this.state.isExceededLimit ? AppMsg.getMessage(AppMsg.APP_ERROR_EMAIL_NOT_SENT) : 
                                    AppMsg.getMessage(AppMsg.APP_ERROR)}
                            />
                        </div> : ''
                    }
                    {this.state.isEmailSent ?
                        <div className="tri-inline-notification-div">
                            <InlineNotification
                                hideCloseButton={false}
                                iconDescription="close"
                                kind="success"
                                notificationType="inline"
                                onCloseButtonClick={() => this._enableContinueButton()}
                                role="alert"
                                statusIconDescription=""
                                title={AppMsg.getMessage(AppMsg.APP_TEMPORARY_PASSWORD_SENT)}
                                subtitle={<>{AppMsg.getMessage(AppMsg.APP_TEMPORARY_PASSWORD_SENT_MSG)}
                                    <div style={{display: "block"}}>
                                        <NotificationActionButton
                                            kind="tertiary"
                                            onClick={() => this.props.resetUserStateFromForgotPwdBackToLogin()} 
                                        >
                                            {AppMsg.getMessage(AppMsg.APP_BACK_TO_LOGIN)}
                                        </NotificationActionButton>
                                    </div></>
                                }
                            />
                        </div> : ''
                    }
                    <hr className='horizontal-line' />
                    <Form onSubmit={this.handleSubmit.bind(this)}>  
                        <div>
                            <TextInput
                                labelText={AppMsg.getMessage(AppMsg.APP_EMAIL_ADDRESS)}
                                id='email'
                                placeholder={AppMsg.getMessage(AppMsg.APP_ENTER_EMAIL_ADDRESS)}
                                invalid={this.state.isInvalidEmail}
                                invalidText={AppMsg.getMessage(AppMsg.APP_INVALID_EMAIL_ADDRESS)}
                                onChange={(e) => this._setEmail(e.target.value)}
                                onAnimationStart={(e) => this._handleAutofill(e)}
                            />
                        </div>  
                        <div>
                            <Button
                                kind="primary"
                                size="field"
                                renderIcon={ArrowRight32}
                                onClick={(e) => {this.handleSubmit(e)}}
                                type="submit"
                                disabled={this.state.disableContinue}>
                                {AppMsg.getMessage(AppMsg.APP_CONTINUE)}
                                {this.state.showEmailLoading ? <><Loading small={true} withOverlay={false} /></> :''}
                            </Button>
                        </div>
                    </Form>
                </div>
            </div>
        );
    }
}

export default ForgotPwdEmailForm;